<template>
    <div
        id="be-elenco-gallery"
        class="bg-light"
    >
        <div class="body-wrapper">
            <backend-header />

            <main>
                <div class="barra-titolo-azioni bg-white border-bottom py-2">
                    <div class="container-fluid">
                        <div class="row d-flex justify-content-between flex-wrap align-items-center">
                            <div class="col-sm-6">
                                <h1 class="mb-0">
                                    {{ $t("Galleria eventi") }}
                                </h1>
                            </div>
                            <div class="col-sm-6 mt-3 mt-sm-0">
                                <ul class="d-sm-flex justify-content-end flex-wrap mb-0">
                                    <li class="d-inline-block">
                                        <button
                                            class="pulsante-nuova-gallery btn btn-primary btn-rikorda1"
                                            v-b-modal.new-gallery-modal
                                        >
                                            {{ $t("Nuovo evento") }}
                                        </button>
                                    </li>
                                    <!--li class="d-inline-block ml-2">
                                        <a
                                            href="#"
                                            type="button"
                                            class="pulsante-modelli btn btn-light border"
                                        >
                                            {{ $t("Modelli") }}
                                        </a>
                                    </li-->
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="container-fluid">
                    <p class="text-center mb-0 mt-3">
                        {{ numPhotos }} {{ $t("foto") }}
                    </p>

                    <ul class="filtri d-flex justify-content-center align-items-center flex-wrap mb-0">
                        <li class="col-md-3 col-xl-2 mt-3">
                            <a
                                type="button"
                                href="javascript:void(0);"
                                class="search d-block border border-dark py-2 pl-2 pr-4 bg-light text-dark position-relative"
                                v-b-modal.popupricerca
                                :class="{ active: isFilterCustom }"
                            >
                                <span class="d-block">
                                    <font-awesome-icon :icon="['fas', 'search']" />
                                </span>
                                <span class="d-block">{{
                                    $t("Ricerca con filtri")
                                }}</span>
                                <span class="overlay-text position-absolute d-flex justify-content-center align-items-center">
                                    <font-awesome-icon :icon="['fas', 'search']" />
                                </span>
                            </a>
                        </li>
                        <li class="col-md-3 col-xl-2 mt-3">
                            <a
                                href="#"
                                class="d-block border border-dark py-2 pl-2 pr-4 bg-light text-dark position-relative"
                                :class="{
                                    active: isFilterAll
                                }"
                                @click.prevent="filterAllEvents()"
                            >
                                <span class="d-block font-weight-bold">{{
                                    numEvents
                                }}</span>
                                <span class="d-block">{{ $t("Tutti") }}</span>
                                <span class="overlay-text font-weight-bold position-absolute d-flex justify-content-center align-items-center">{{ numEvents }}</span>
                            </a>
                        </li>
                        <li class="col-md-3 col-xl-2 mt-3">
                            <a
                                href="#"
                                class="d-block border border-dark py-2 pl-2 pr-4 bg-light text-dark position-relative"
                                :class="{
                                    active: isFilterActive
                                }"
                                @click.prevent="filterActiveEvents()"
                            >
                                <span class="d-block font-weight-bold">{{
                                    numActiveEvents
                                }}</span>
                                <span class="d-block">{{ $t("Attivi") }}</span>
                                <span class="overlay-text font-weight-bold position-absolute d-flex justify-content-center align-items-center">{{ numActiveEvents }}</span>
                            </a>
                        </li>
                        <li class="col-md-3 col-xl-2 mt-3">
                            <a
                                href="#"
                                class="d-block border border-dark py-2 pl-2 pr-4 bg-light text-dark position-relative"
                                :class="{
                                    active: isFilterInactive
                                }"
                                @click.prevent="filterInactiveEvents()"
                            >
                                <span class="d-block font-weight-bold">{{
                                    numInactiveEvents
                                }}</span>
                                <span class="d-block">{{
                                    $t("Non attivi")
                                }}</span>
                                <span class="overlay-text font-weight-bold position-absolute d-flex justify-content-center align-items-center">{{ numInactiveEvents }}</span>
                            </a>
                        </li>
                    </ul>

                    <div class="controlli-elenco mt-5 d-flex justify-content-between align-items-center flex-wrap">
                        <div class="d-md-flex justify-content-start align-items-center col-md-12 mt-3 mt-md-0 pl-0">
                            <div class="selettore-griglia-lista d-flex justify-content-end col-md-12">
                                <b-dropdown
                                    variant="light border"
                                    class="mr-4"
                                    dropdown
                                    right
                                    :style="{ visibility: (gridView ? '' : 'hidden')}"
                                    v-model="selectedSortOption"
                                >
                                    <template v-slot:button-content>
                                        {{ $t("Ordina per") }}
                                    </template>

                                    <b-dropdown-item
                                        v-for="option in gridSortOptions"
                                        :key="option.sortBy + '-' + (option.sortDesc ? 'desc' : 'asc')"
                                        @click="onGridViewSortChanged(option)"
                                    >
                                        {{ option.label }}
                                        <font-awesome-icon
                                            :icon="['fa', 'check']"
                                            v-if="(selectedSortOption.sortBy==option.sortBy && selectedSortOption.sortDesc==option.sortDesc)"
                                        />
                                    </b-dropdown-item>
                                </b-dropdown>

                                <!--b-select
                                    v-if="gridView"
                                    class="form-control selettore-griglia d-inline-flex justify-content-center align-items-center p-1 border mr-4"
                                    style="height: 1.75rem;"
                                    @change="onGridViewSortChanged"
                                >
                                    <b-select-option
                                        v-for="option in gridSortOptions"
                                        :key="option.sortBy + '-' + (option.sortDesc ? 'desc' : 'asc')"
                                        :value="option"
                                    >{{option.label}}
                                    </b-select-option>
                                </b-select-->

                                <component
                                    :is="!gridView ? 'a' : 'span'"
                                    :href="''"
                                    class="selettore-griglia d-inline-flex justify-content-center align-items-center p-1 border my-auto"
                                    :class="{ active: gridView }"
                                    @click.prevent="gridView = true"
                                >
                                    <font-awesome-icon :icon="['fa', 'th']" />
                                </component>
                                <component
                                    :is="gridView ? 'a' : 'span'"
                                    :href="''"
                                    class="selettore-lista d-inline-flex justify-content-center align-items-center p-1 border my-auto"
                                    :class="{ active: !gridView }"
                                    @click.prevent="gridView = false"
                                >
                                    <font-awesome-icon :icon="['fa', 'th-list']" />
                                </component>
                            </div>
                        </div>
                    </div>

                    <ul
                        v-if="gridView"
                        class="elenco-gallery griglia row d-flex justify-content-start flex-wrap mb-0"
                    >
                        <li class="col-sm-6 col-md-4 col-lg-3 mt-3 d-none d-sm-block justify-content-center flex-column">
                            <div class="card-body h-100 bg-white p-4 text-center d-flex justify-content-center flex-column flex-wrap border border-dark">
                                <h2 class="mb-0 mt-2">{{ $t("Crea nuovo evento") }}</h2>
                                <div class="mt-2">
                                    <button
                                        class="pulsante-crea-gallery btn btn-primary btn-rikorda1"
                                        v-b-modal.new-gallery-modal
                                    >{{ $t("Crea") }}</button>
                                </div>
                            </div>
                        </li>
                        <li
                            v-for="event in filteredEvents"
                            :key="event.id"
                            class="col-sm-6 col-md-4 col-lg-3 mt-3 d-flex justify-content-center flex-column"
                        >
                            <a
                                class="gallery border border-dark position-relative h-100 text-light"
                                :style="{
                                    'background-image':
                                        'url(' +
                                        getPreviewUrl(event.coverPhotoId) +
                                        ')'
                                }"
                                @click="goToEvent(event.id)"
                            >
                                <div class="top-text position-absolute">
                                    <span class="titolo d-block">
                                        {{ event.title }}
                                    </span>
                                    <span class="num-foto d-block">
                                        {{ event.numPhotos }}
                                        {{ $t("foto") }}
                                    </span>
                                </div>
                                <div class="bottom-text position-absolute">
                                    <span class="autore small">
                                        {{ event.author}}
                                    </span>
                                </div>
                            </a>

                            <!-- menu azioni -->
                            <b-button-group @click="selectEvent(event)">
                                <b-dropdown
                                    :text="$t('Azioni')"
                                    dropup
                                    class="w-100"
                                    toggle-class="btn btn-light border rounded-0 dropdown-toggle w-100"
                                    menu-class="w-100 text-center"
                                >
                                    <b-dropdown-item :href="
                                            resolveUrl({
                                                name: 'backend-reports-visitors',
                                                params: { eventId: event.id }
                                            })
                                        ">{{ $t("Visitatori") }}</b-dropdown-item>
                                    <b-dropdown-item
                                        :href="
                                            resolveUrl({
                                                name: 'gallery',
                                                params: {
                                                    galleryUrl: event.url.replace(
                                                        '/gallery/',
                                                        ''
                                                    )
                                                }
                                            })
                                        "
                                        target="_blank"
                                    >
                                        {{ $t("Anteprima") }}
                                    </b-dropdown-item>
                                    <b-dropdown-item v-b-modal.popupcondivisione>
                                        {{ $t("Condividi") }}
                                    </b-dropdown-item>
                                    <!--b-dropdown-item href="#">{{
                                        $t("Archivia")
                                    }}</b-dropdown-item-->
                                    <b-dropdown-item :href="
                                            resolveUrl({
                                                name:
                                                    'backend-gallery-settings',
                                                params: {
                                                    eventId: event.id
                                                }
                                            })
                                        ">{{
                                            $t("Impostazioni")
                                        }}</b-dropdown-item>
                                    <b-dropdown-item
                                        href="#"
                                        link-class="text-danger"
                                        v-b-modal.popupcancellazione
                                    >{{ $t("Elimina") }}</b-dropdown-item>
                                </b-dropdown>
                            </b-button-group>
                        </li>
                    </ul>

                    <div v-else>
                        <b-table
                            striped
                            class="elenco-gallery lista tabella-responsive table table-striped mt-3 mb-0"
                            id="gallery-table"
                            :per-page="pagination.perPage"
                            :current-page="pagination.currentPage"
                            :items="filteredEvents"
                            :fields="tableHead"
                            :tbody-tr-class="'gallery mt-0'"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                        >

                            <!-- HEAD -->
                            <template #head(preview)="data">
                                <span class="px-1">{{ data.label }}</span>
                            </template>
                            <template #head(title)="data">
                                <span class="px-1">{{ data.label }}</span>
                            </template>
                            <template #head(numPhotos)="data">
                                <span class="px-1">{{ data.label }}</span>
                            </template>
                            <template #head(date)="data">
                                <span class="px-1">{{ data.label }}</span>
                            </template>
                            <template #head(dateExpire)="data">
                                <span class="px-1">{{ data.label }}</span>
                            </template>
                            <template #head(actions)="data">
                                <span class="px-1">{{ data.label }}</span>
                            </template>

                            <!-- TABLE BODY DATA -->
                            <template #thead-top>
                                <b-tr>
                                    <b-th
                                        colspan="6"
                                        class="p-0"
                                    >
                                        <div class="card-body bg-white p-4 text-center d-flex justify-content-center flex-column flex-wrap">
                                            <h2 class="mb-0 mt-2">{{ $t("Crea nuovo evento") }}</h2>
                                            <div class="mt-2">
                                                <button
                                                    class="pulsante-crea-gallery btn btn-primary btn-rikorda1"
                                                    v-b-modal.new-gallery-modal
                                                >{{ $t("Crea") }}</button>
                                            </div>
                                        </div>
                                    </b-th>
                                </b-tr>
                            </template>

                            <template #cell(preview)="data">
                                <a href="#">
                                    <div
                                        class="img d-inline-block"
                                        :style="{
                                                'background-image':
                                                    'url(' +
                                                    getPreviewUrl(
                                                        data.item.coverPhotoId
                                                    ) +
                                                    ')'
                                            }"
                                    ></div>
                                </a>
                            </template>

                            <template #cell(title)="data">
                                <span class="titolo d-block font-weight-bold"><a href="#">{{ data.item.title }}</a></span>
                                <span class="autore d-block small">{{data.item.author}}</span>
                                <span class="status d-block mt-2">{{$t(data.item.state)}}</span>
                            </template>

                            <template #cell(numPhotos)="data">
                                <span class="px-1">{{ data.item.numPhotos }} {{ $t('foto') }}</span>
                            </template>

                            <template #cell(date)="data">
                                <span
                                    class="px-1"
                                    v-if="data.item.date"
                                >{{ data.item.date | formatDateSlash }}</span>
                                <span
                                    class="px-1"
                                    v-else
                                >-</span>
                            </template>

                            <template #cell(dateExpire)="data">
                                <span
                                    class="px-1"
                                    v-if="data.item.dateExpire"
                                >{{ data.item.dateExpire | formatDateSlash }}</span>
                                <span
                                    class="px-1"
                                    v-else
                                >-</span>
                            </template>

                            <template #cell(actions)="data">
                                <!-- menu azioni -->
                                <b-button-group>
                                    <b-dropdown
                                        :text="$t('Azioni')"
                                        dropdown
                                        right
                                        class="w-100"
                                        toggle-class="btn btn-light border rounded-pill dropdown-toggle w-100"
                                        menu-class="w-100 text-center"
                                    >
                                        <b-dropdown-item :href="
                                                    resolveUrl({
                                                        name:
                                                            'backend-reports-visitors',
                                                        params: {
                                                            eventId: data.item.id
                                                        }
                                                    })
                                                ">{{
                                                    $t("Visitatori")
                                                }}</b-dropdown-item>
                                        <b-dropdown-item
                                            :href="
                                                    resolveUrl({
                                                        name: 'gallery',
                                                        params: {
                                                            galleryUrl: data.item.url.replace(
                                                                '/gallery/',
                                                                ''
                                                            )
                                                        }
                                                    })
                                                "
                                            target="_blank"
                                        >{{
                                                    $t("Anteprima")
                                                }}</b-dropdown-item>
                                        <b-dropdown-item v-b-modal.popupcondivisione>
                                            {{ $t("Condividi") }}
                                        </b-dropdown-item>
                                        <b-dropdown-item :href="
                                                    resolveUrl({
                                                        name:
                                                            'backend-gallery-settings',
                                                        params: {
                                                            eventId: data.item.id
                                                        }
                                                    })
                                                ">{{
                                                    $t("Impostazioni")
                                                }}</b-dropdown-item>
                                        <b-dropdown-item
                                            href="#"
                                            link-class="text-danger"
                                            v-b-modal.popupcancellazione
                                        >{{
                                                    $t("Elimina")
                                                }}</b-dropdown-item>
                                    </b-dropdown>
                                </b-button-group>
                            </template>
                        </b-table>

                        <nav
                            class="paginazione mt-3"
                            aria-label="Paginazione"
                        >
                            <b-pagination
                                v-model="pagination.currentPage"
                                :total-rows="paginationRows"
                                :per-page="pagination.perPage"
                                aria-controls="emails-table"
                                align="right"
                                class="pagination justify-content-end mb-0"
                            />
                        </nav>
                    </div>
                </div>
            </main>

            <backend-footer />

            <!-- popup ricerca gallery -->
            <b-modal
                id="popupricerca"
                :title="$t('Cerca galleria')"
                @show="resetSearchModal"
                @hidden="resetSearchModal"
                @ok="filterCustom"
            >
                <div class="form-group mt-3">
                    <label for="searchTitle">{{ $t("Titolo") }}</label>
                    <input
                        type="text"
                        class="form-control"
                        name="searchTitle"
                        id="searchTitle"
                        v-model="searchGallery.title"
                    />
                </div>
                <div class="form-group mt-3">
                    <label for="searchYear">{{ $t("Anno") }}</label>
                    <input
                        type="number"
                        min="2000"
                        class="form-control"
                        name="searchYear"
                        id="searchYear"
                        v-model="searchGallery.year"
                    />
                </div>
                <div
                    class="form-group mt-3"
                    v-if="!isAgent"
                >
                    <label>{{ $t("Collaboratore") }}</label>
                    <b-form-select
                        class="form-control"
                        v-model="searchGallery.agent"
                        :options="agents"
                        value-field="fkUtenteAgente"
                        text-field="email"
                        required
                    >
                        <template #first>
                            <b-form-select-option value="">{{$t('Tutti')}}</b-form-select-option>
                        </template>
                    </b-form-select>
                </div>
                <template v-slot:modal-footer="{ ok, cancel }">
                    <b-button
                        class="btn btn-light border"
                        @click="cancel()"
                    >
                        {{ $t("Chiudi") }}
                    </b-button>
                    <b-button
                        class="btn btn-primary btn-rikorda1"
                        @click="ok()"
                    >
                        {{ $t("Cerca") }}
                    </b-button>
                </template>
            </b-modal>

            <!-- popup nuova gallery -->
            <b-modal
                id="new-gallery-modal"
                :title="$t('Nuovo evento')"
                @show="resetNewGalleryModal"
                @hidden="resetNewGalleryModal"
                @ok="createNewGallery"
            >
                <p class="text-danger mb-0">* {{ $t("Campi obbligatori") }}</p>

                <b-form-row class="mt-3">
                    <b-form-group class="col-sm-12 col-md-12">
                        <label>{{ $t("Titolo") }}&nbsp;<span class="text-danger">*</span></label>
                        <b-form-input
                            v-model="newGallery.title"
                            trim
                        ></b-form-input>
                    </b-form-group>
                </b-form-row>

                <b-form-row class="mt-3">
                    <b-form-group class="col-sm-12 col-md-6">
                        <label>{{ $t("Stato") }}&nbsp;<span class="text-danger">*</span></label>
                        <b-form-select v-model="newGallery.state">
                            <b-form-select-option value="ATTIVO">
                                {{ $t("Attivo") }}
                            </b-form-select-option>
                            <b-form-select-option value="NON ATTIVO">
                                {{ $t("Non attivo") }}
                            </b-form-select-option>
                        </b-form-select>
                    </b-form-group>

                    <b-form-group class="col-sm-12 col-md-6">
                        <label>{{ $t("Data") }}&nbsp;<span class="text-danger">*</span></label>
                        <b-form-datepicker
                            v-model="newGallery.date"
                            trim
                            min="2000-01-01"
                            max="2099-12-31"
                            :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                            :label-help="$t('Usa i tasti freccia navigare tra le date')"
                        ></b-form-datepicker>
                    </b-form-group>
                </b-form-row>

                <b-form-row class="mt-3">
                    <b-form-group class="col-sm-12 col-md-6">
                        <label>{{ $t("Modalità") }}&nbsp;<span class="text-danger">*</span></label>
                        <b-form-select v-model="newGallery.mode">
                            <b-form-select-option value="DEFAULT">
                                {{ $t("Visione e vendita") }}
                            </b-form-select-option>
                            <b-form-select-option value="VIEWONLY">
                                {{ $t("Solo visione") }}
                            </b-form-select-option>
                        </b-form-select>
                    </b-form-group>

                    <b-form-group
                        class="col-sm-12 col-md-6"
                        v-show="newGallery.mode!='VIEWONLY'"
                    >
                        <label>{{ $t("Listino") }}&nbsp;<span class="text-danger">*</span></label>
                        <b-form-select v-model="newGallery.pricelistId">
                            <b-form-select-option
                                v-for="pricelist in pricelists"
                                :key="pricelist.idListino"
                                :value="pricelist.idListino"
                            >
                                {{ pricelist.nome }}
                            </b-form-select-option>
                        </b-form-select>
                    </b-form-group>
                </b-form-row>

                <template v-slot:modal-footer="{ ok, cancel }">
                    <b-button
                        class="btn btn-light border"
                        @click="cancel()"
                    >
                        {{ $t("Annulla") }}
                    </b-button>
                    <b-button
                        class="btn btn-primary btn-rikorda1"
                        @click="ok()"
                    >
                        {{ $t("Aggiungi") }}
                    </b-button>
                </template>
            </b-modal>

            <!-- popup cancellazione gallery -->
            <b-modal
                id="popupcancellazione"
                :title="$t('Elimina la galleria')"
                @show="resetSelectEvent"
                @hidden="resetSelectEvent"
                @ok="removeGallery"
            >
                <p class="mb-0">
                    {{
                        $t(
                            "Sei sicuro di voler eliminare la galleria [TITOLO]?",
                            { title: selectedEventTitle }
                        )
                    }}
                </p>
                <p class="mb-0 mt-1">
                    {{
                        $t(
                            "La galleria non sarà più accessibile. Questa azione non può essere annullata!"
                        )
                    }}
                </p>
                <p class="mb-0 mt-1">
                    {{
                        $t(
                            "Anche le foto e le informazioni sui visitatori della galleria verranno eliminati."
                        )
                    }}
                </p>

                <template v-slot:modal-footer="{ ok, cancel }">
                    <b-button
                        class="btn btn-light border"
                        @click="cancel()"
                    >
                        {{ $t("Annulla") }}
                    </b-button>
                    <b-button
                        class="btn btn-primary btn-danger"
                        @click="ok()"
                    >
                        {{ $t("Elimina") }}
                    </b-button>
                </template>
            </b-modal>

            <!-- popup condivisione gallery -->
            <b-modal
                id="popupcondivisione"
                :title="$t('Condividi la galleria')"
                hide-footer
                @show="resetSelectEvent"
                @hidden="resetSelectEvent"
            >
                <b-row>
                    <b-col class="text-center">
                        <b-button
                            class="btn btn-primary btn-rikorda1"
                            @click="onGalleryShareByMail"
                        >
                            {{ $t("Tramite mail") }}
                        </b-button>
                    </b-col>
                </b-row>
                <b-row class="mt-2 mb-2">
                    <b-col class="text-center">
                        {{ $t("oppure") }}
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="text-center">
                        <b-form-input
                            :value="selectedEvent.link"
                            readonly
                            ref="linkInput"
                            class="d-none"
                        ></b-form-input>
                        <b-button
                            class="btn btn-primary btn-rikorda1"
                            v-b-modal.copy-link-modal
                        >
                            {{ $t("Tramite link") }}
                        </b-button>
                    </b-col>
                </b-row>
            </b-modal>

        </div>

        <notification
            :position="notificationPosition"
            :variant="notificationVariant"
            :message="notificationMessage"
            ref="notification"
        ></notification>

        <copy-link
            :link="selectedEvent.link"
            @linkCopied="onGalleryLinkCopied"
        />
    </div>
</template>

<script>
import moment from "moment";
import Notification from "../../components/Notification";
import BackendHeader from "../../components/backend/Header";
import BackendFooter from "../../components/backend/Footer";
import CopyLink from "../../components/CopyLink";

const FILTER_CUSTOM = "custom";
const FILTER_ALL = "all";
const FILTER_ACTIVE = "active";
const FILTER_INACTIVE = "inactive";

export default {
    name: "BackendGalleries",

    components: {
        CopyLink,
        Notification,
        BackendHeader,
        BackendFooter
    },

    data() {
        return {
            gridView: true,
            gridSortOptions: [
                {
                    sortBy: "title",
                    sortDesc: false,
                    label: "Titolo A-Z"
                },
                {
                    sortBy: "title",
                    sortDesc: true,
                    label: "Titolo Z-A"
                },
                {
                    sortBy: "dateAdded",
                    sortDesc: false,
                    label: "Data creazione A-Z"
                },
                {
                    sortBy: "dateAdded",
                    sortDesc: true,
                    label: "Data creazione Z-A"
                }
            ],
            selectedSortOption: { sortBy: "dateAdded", sortDesc: true },
            events: [],
            filteredEvents: [],
            pagination: {
                perPage: 10,
                currentPage: 1
            },
            sortBy: "date",
            sortDesc: true,
            tableHead: [
                {
                    key: "preview",
                    label: "",
                    thClass: "px-1",
                    tdClass: "align-middle px-1",
                    tdAttr: { "data-title": "" }
                },
                {
                    key: "title",
                    label: "Nome",
                    thClass: "px-1",
                    tdClass: "align-middle px-1",
                    tdAttr: { "data-title": "Nome" },
                    sortable: true
                },
                {
                    key: "numPhotos",
                    label: "Foto",
                    thClass: "px-1",
                    tdClass: "align-middle px-1",
                    tdAttr: { "data-title": "Foto" },
                    sortable: true
                },
                {
                    key: "date",
                    label: "Data",
                    thClass: "px-1",
                    tdClass: "align-middle px-1",
                    tdAttr: { "data-title": "Data" },
                    sortable: true
                },
                {
                    key: "dateExpire",
                    label: "Scadenza",
                    thClass: "px-1",
                    tdClass: "align-middle px-1",
                    tdAttr: { "data-title": "Scadenza" },
                    sortable: true
                },
                {
                    key: "actions",
                    label: "",
                    thClass: "px-1",
                    tdClass: "align-middle text-right px-1",
                    tdAttr: { "data-title": "" }
                }
            ],
            numEvents: 0,
            numPhotos: 0,
            numActiveEvents: 0,
            numInactiveEvents: 0,
            activeFilter: FILTER_ALL,
            newGallery: {
                title: "",
                state: "ATTIVO",
                mode: "DEFAULT",
                date: new Date().toISOString().split("T")[0],
                pricelistId: ""
            },
            pricelists: [],
            searchGallery: {
                title: "",
                year: 2000,
                agent: ""
            },
            selectedEvent: {},
            selectedEventTitle: "",
            agents: {},
            notification: {
                time: 0,
                position: "bottom-right",
                variant: "",
                message: ""
            }
        };
    },

    mounted() {
        this.$api
            .backendGetEventsData()
            .then((result) => {
                console.debug("BACKEND_GET_EVENTS_DATA", result);
                this.events = result.events;
                // imposta ordinamento iniziale eventi
                this.onGridViewSortChanged(this.selectedSortOption);
                this.filteredEvents = this.events;
                this.activeFilter = FILTER_ALL;

                // setup contatori
                this.setCounters();

                this.pricelists = result.pricelists;
                this.agents = result.agents;
                if (this.isAgent && this.events.length > 0) {
                    this.searchGallery.agent = this.events[0].fkUtenteAgente;
                }
            })
            .catch((error) => {
                console.error("BACKEND_GET_EVENTS_DATA", error);
                this.$router.push({
                    name: this.$route.meta.gotoOnAuthFailed,
                    params: this.$route.params
                });
            });
    },

    methods: {
        onGridViewSortChanged(selectedSortOption) {
            this.selectedSortOption = selectedSortOption;
            this.events = this.events.sort(function (a, b) {
                var result = 0;
                switch (selectedSortOption.sortBy) {
                    case "title":
                        if (a.title < b.title) {
                            result = -1;
                        }
                        if (a.title > b.title) {
                            result = 1;
                        }
                        return !selectedSortOption.sortDesc ? result : -result;
                    case "dateAdded":
                        if (a.dateAdded < b.dateAdded) {
                            result = -1;
                        }
                        if (a.dateAdded > b.dateAdded) {
                            result = 1;
                        }
                        return !selectedSortOption.sortDesc ? result : -result;
                    default:
                        return 0;
                }
            });

            switch (this.activeFilter) {
                case FILTER_ALL:
                    this.filterAllEvents();
                    break;
                case FILTER_ACTIVE:
                    this.filterActiveEvents();
                    break;
                case FILTER_INACTIVE:
                    this.filterInactiveEvents();
                    break;
                case FILTER_CUSTOM:
                    this.filterCustom();
                    break;
            }
        },

        resetNewGalleryModal() {
            this.newGallery.title = "";
            this.newGallery.state = "ATTIVO";
            this.newGallery.mode = "DEFAULT";
            this.newGallery.date = new Date().toISOString().split("T")[0];
            this.newGallery.pricelistId = "";

            if (this.pricelists.length > 0) {
                this.newGallery.pricelistId = this.pricelists[0].idListino;
            }
        },

        createNewGallery($event) {
            if (
                this.newGallery.title.length > 0 &&
                this.newGallery.date.length > 0
            ) {
                this.$api
                    .backendCreateEvent(this.newGallery)
                    .then((response) => {
                        if (response.eventId && response.eventId.length > 0) {
                            this.resetNewGalleryModal();
                            this.goToEvent(response.eventId);
                        }
                    });
            } else {
                $event.preventDefault();
            }
        },

        getPreviewUrl(photoId) {
            return this.$imagesService.getUrl(photoId, "web", false);
        },

        setCounters() {
            this.numEvents = this.events.length;
            this.numActiveEvents = 0;
            this.numInactiveEvents = 0;
            this.numPhotos = 0;
            this.events.forEach((event) => {
                this.numPhotos += event.numPhotos;
                switch (event.state) {
                    case "ATTIVO":
                        this.numActiveEvents += 1;
                        break;
                    case "NON ATTIVO":
                        this.numInactiveEvents += 1;
                        break;
                    default:
                        break;
                }
            });
        },

        filterAllEvents() {
            this.filteredEvents = this.events;
            this.activeFilter = FILTER_ALL;
        },

        filterActiveEvents() {
            this.filteredEvents = this.events.filter((event) => {
                return event.state === "ATTIVO";
            });
            this.activeFilter = FILTER_ACTIVE;
        },

        filterInactiveEvents() {
            this.filteredEvents = this.events.filter((event) => {
                return event.state === "NON ATTIVO";
            });
            this.activeFilter = FILTER_INACTIVE;
        },

        resetSearchModal() {
            this.searchGallery.title = "";
            this.searchGallery.date = 2000;
            if (!this.isAgent) {
                this.searchGallery.agent = "";
            }
        },

        filterCustom() {
            this.filteredEvents = this.events.filter((event) => {
                var eventYear = moment(String(event.date)).year();
                if (eventYear && this.searchGallery.agent) {
                    return (
                        event.title.includes(this.searchGallery.title) &&
                        eventYear >= this.searchGallery.year &&
                        event.fkUtenteAgente === this.searchGallery.agent
                    );
                }
                return event.title.includes(this.searchGallery.title);
            });
            this.activeFilter = FILTER_CUSTOM;
        },

        clearFilter(filter) {
            switch (filter) {
                case "title":
                    this.searchGallery.title = "";
                    this.filterCustom();
                    break;
                case "year":
                    this.searchGallery.year = "";
                    this.filterCustom();
                    break;
                case "agent":
                    this.searchGallery.agent = "";
                    this.filterCustom();
                    break;
                default:
                    this.searchGallery.title = "";
                    this.searchGallery.year = "";
                    if (!this.isAgent) {
                        this.searchGallery.agent = "";
                    }
                    this.filterCustom();
                    break;
            }
        },

        selectEvent(event) {
            this.selectedEvent = event;
            this.selectedEventTitle = event.title;
        },

        resetSelectEvent() {
            this.selectedEvent = {};
            this.selectedEventTitle = "";
        },

        onGalleryShareByMail() {
            this.$bvModal.hide("popupcondivisione");
            this.$router.push({
                name: "backend-gallery-share",
                params: { eventId: this.selectedEvent.id }
            });
        },

        onGalleryLinkCopied(successful) {
            if (successful) {
                this.notification.message = "Link evento copiato negli appunti";
                this.notification.variant = "success";
            } else {
                this.notification.message =
                    "Link evento non copiato negli appunti";
                this.notification.variant = "warning";
            }

            this.notification.position = "bottom-right";
            this.$refs.notification.time = 3000;

            window.getSelection().removeAllRanges();
        },

        removeGallery($event) {
            if (this.selectedEvent) {
                var eventId = this.selectedEvent.id;
                this.$api.backendDeleteEvent(eventId).then(() => {
                    var i;
                    for (i = 0; i < this.events.length; i++) {
                        if (this.events[i].id === eventId) {
                            this.events.splice(i, 1);
                        }
                    }

                    for (i = 0; i < this.filteredEvents.length; i++) {
                        if (this.filteredEvents[i].id === eventId) {
                            this.filteredEvents.splice(i, 1);
                        }
                    }

                    this.setCounters();
                });
            } else {
                $event.preventDefault();
            }
        },

        resolveUrl(data) {
            const resolver = this.$router.resolve(data);
            return resolver.resolved.matched.length ? resolver.href : "#";
        },

        goToEvent(eventId) {
            this.$router.push({
                name: "backend-gallery",
                params: { eventId: eventId }
            });
        }
    },

    computed: {
        isFilterAll() {
            return this.activeFilter === FILTER_ALL;
        },

        isFilterActive() {
            return this.activeFilter === FILTER_ACTIVE;
        },

        isFilterInactive() {
            return this.activeFilter === FILTER_INACTIVE;
        },

        isFilterCustom() {
            return this.activeFilter === FILTER_CUSTOM;
        },

        isAgent() {
            var userDataBE = this.$store.getters.userDataBE;
            var isAgent = this.$store.getters.isAgent;
            console.debug("USERDATABE", userDataBE);
            return userDataBE && isAgent;
        },

        notificationPosition() {
            return this.notification.position;
        },

        notificationVariant() {
            return this.notification.variant;
        },

        notificationMessage() {
            return this.notification.message;
        },

        paginationRows() {
            return this.filteredEvents.length;
        }
    }
};
</script>

<style scoped></style>
